import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { ApiService } from '../__api/api.service';

@Injectable({
  providedIn: 'root'
})
export class ClientBoardResolver implements Resolve<any> {

  constructor(private api: ApiService) {}

  // Resolver that fetches all needed data before route loads
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const userId = '1'; // TODO

    return forkJoin({
      clientBoardData: this.api.getClientDashboardData('dashboard')
    });
  }
}